import Api from "../utils/api";

const ClientService = {
  admin: {
    get: async (params = {}) =>
      Api.createResponse("app/admin/clients/", params),
    update: async (params = {}) =>
      Api.createResponse("app/admin/clients/update", params),
    create: async (params = {}) =>
      Api.createResponse("app/admin/clients/create", params),
    delete: async (params = {}) =>
      Api.createResponse("app/admin/clients/delete", params),
    getDefaultTarifa: async (params = {}) =>
      Api.createResponse("app/admin/clients/default-tarifa", params),
  },
};

export default ClientService;
